import { ButtonLink } from "@ui/ButtonLink";
import { HStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { pluralise } from "@utils/text";
import type { Resource } from "solid-js";
import type { InfluencerPublicProfile, ListBoardsResponse } from "@/client";

type Props = {
	influencer: InfluencerPublicProfile;
	boards: Resource<ListBoardsResponse>;
};

export const PublicBoardsProfileTitle = (props: Props) => {
	return (
		<HStack spacing="small" justify="space-between" align="center">
			<Text
				family="mono"
				transform="uppercase"
				weight="bold"
				size="small"
				color="fg3"
			>
				Boards
			</Text>
			<HStack spacing="small" align="center">
				<Text
					family="mono"
					transform="uppercase"
					weight="bold"
					size="small"
					color="fg4"
				>
					{props.boards()?.total ?? 0}{" "}
					{pluralise(props.boards()?.total ?? 0, "board")}
				</Text>
				<ButtonLink variant="text" href={`/@${props.influencer.handle}/boards`}>
					<Text
						family="mono"
						size="small"
						weight="bold"
						transform="uppercase"
						color="primary"
					>
						View all
					</Text>
				</ButtonLink>
			</HStack>
		</HStack>
	);
};
